/*
   Shows a list of devices against a pre_factoryfixture_devicegroup
*/

import _ from 'underscore';
import Radio from 'backbone.radio';
import strings_specific from 'amdi18n-loader!@/nls/device_group_list';
import strings_common from 'amdi18n-loader!@/nls/common';
const globalCh = Radio.channel('global');
const strings = _.extend({}, strings_common, strings_specific);

function title(devicegroup) {
  return devicegroup.get('name') + ' Test Fixtures';
}

const columns = [{
    name: '',
    class_name: 'select',
    sortable: false,
    select_all: true
}, {
    name: strings.device_id,
    class_name: 'name',
    sortable: false,
}, {
    name: 'Status',
    class_name: 'status',
    sortable: false,
}, {
    name: strings.owner,
    class_name: 'owner',
    sortable: false,
}, {
    name: 'Last Enrolled',
    class_name: 'enrolled',
    sortable: false,
    sort_by: 'last_enrolled_at'
}, {
    name: 'Manage'
}];

export default function show_pre_factoryfixture_devices(devicegroup) {
    function load_relationships() {
        return devicegroup.rel.load_all();
    }
    function show_devices() {
        globalCh.request(
            'show_devices',
            {
                devicegroup: devicegroup,
                product: devicegroup.rel.get('product')
            },
            columns,
            title(devicegroup),
            {
                show: {
                    rel_owner: true,
                    rel_account: false,
                    rel_product: false,
                    rel_devicegroup: false,
                }
            }
        );
    }
    function error(reason) {
        alert('Device Group lookup failed: ' + reason);
    }
    devicegroup.load()
        .then(load_relationships)
        .then(show_devices)
        .fail(error)
        ;

}

